module.exports = __webpack_public_path__ + "img/step3-b.d321e157.png";